let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4JHKG")).then(() => parcelRequire('1xJmc'));